module.exports = __webpack_public_path__ + "static/media/hibuscars.1a77615b.webp";